
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PushNotificationsListView from "./push_notifications-list.html";
import PushNotificationsEditView from "./push_notifications-edit.html";

angular.module("push_notifications", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('push_notifications', {
                url: "/push_notifications",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('push_notifications.list', {
                url: "/list",
                controller: "PushNotificationsListCtrl",
                template: PushNotificationsListView,
                // requiredPermission: ["MAILINGS_READ"]
            })
            .state('push_notifications.edit', {
                url: "/edit/:notificationId",
                controller: "PushNotificationsEditCtrl",
                template: PushNotificationsEditView,
                // requiredPermission: ["MAILINGS_READ"]
            })
    }])
    ;